import { resolveAssetUrl } from '@speeki/frontend-utils';

import { Description, EmptyListWrapper, Title } from './EmptyList.styled';

export interface EmptyListProps {
    description: string;
    icon: string;
    title: string;
}

export const EmptyList = ({ description, icon, title }: EmptyListProps) => {
    return (
        <EmptyListWrapper>
            <img alt="No active items" src={resolveAssetUrl(icon)} />
            <Title>{title}</Title>
            <Description>{description}</Description>
        </EmptyListWrapper>
    );
};
